export default "__VITE_PUBLIC_ASSET__04fd42d0__"